var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-framework";
import { DateTimeHelper } from "../../helpers/date-time-helper";
var NotificationClientService = /** @class */ (function () {
    function NotificationClientService() {
        this._showFuncs = [];
        this._hideFuncs = [];
    }
    // SHOW DIALOG FUNCTIONS
    NotificationClientService.prototype.subscribeShow = function (funcShow) {
        var index = this._showFuncs.indexOf(funcShow);
        if (index < 0) {
            this._showFuncs.push(funcShow);
        }
    };
    NotificationClientService.prototype.unSubscribeShow = function (showFunc) {
        var index = this._showFuncs.indexOf(showFunc);
        if (index > -1) {
            this._showFuncs.splice(this._showFuncs.indexOf(showFunc), 1);
        }
    };
    NotificationClientService.prototype.show = function (title, description, notificationType, time, actionText, actionHandler, persistInServer) {
        var e_1, _a;
        if (time === void 0) { time = 5000; }
        if (actionText === void 0) { actionText = null; }
        if (actionHandler === void 0) { actionHandler = null; }
        if (persistInServer === void 0) { persistInServer = false; }
        try {
            for (var _b = __values(this._showFuncs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var func = _c.value;
                func({
                    title: title,
                    description: description,
                    notificationType: notificationType,
                    time: time,
                    isHidden: false,
                    actionText: actionText,
                    hasBeenSeen: false,
                    actionHandler: actionHandler,
                    persistInServer: persistInServer,
                    date: DateTimeHelper.getDateFormatted(new Date()),
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    // HIDE DIALOG FUNCTIONS
    NotificationClientService.prototype.subscribeHide = function (funcHide) {
        this._hideFuncs.push(funcHide);
    };
    NotificationClientService.prototype.unSubscribeHide = function (funcHide) {
        this._hideFuncs.splice(this._hideFuncs.indexOf(funcHide), 1);
    };
    NotificationClientService.prototype.hide = function () {
        var e_2, _a;
        try {
            for (var _b = __values(this._hideFuncs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var func = _c.value;
                func();
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    NotificationClientService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [])
    ], NotificationClientService);
    return NotificationClientService;
}());
export { NotificationClientService };
export var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["Info"] = 1] = "Info";
    NotificationType[NotificationType["Success"] = 2] = "Success";
    NotificationType[NotificationType["Warning"] = 3] = "Warning";
    NotificationType[NotificationType["Error"] = 4] = "Error";
})(NotificationType || (NotificationType = {}));
var NotificationModel = /** @class */ (function () {
    function NotificationModel() {
    }
    return NotificationModel;
}());
export { NotificationModel };
